export const CREATE_ORDERSTOCKS35474 = "CREATE_ORDERSTOCKS35474";
export const UPDATE_ORDERSTOCKS35474 = "UPDATE_ORDERSTOCKS35474";
export const DELETE_ORDERSTOCKS35474 = "DELETE_ORDERSTOCKS35474";
export const FETCH_ORDERSTOCKS35474 = "FETCH_ORDERSTOCKS35474";
export const LISTEN_TO_SELECTED_ORDERSTOCKS35474 =
  "LISTEN_TO_SELECTED_ORDERSTOCKS35474";
